import { CountryAddressFieldKeyMap } from './Interface';

export const REVAMPED_SCREENS = {
  ocrVerification: 'ocr_verification',
  jumioInitiate: 'jumio_initiate',
  onfidoInitiate: 'onfido_initiate',
  jumioVerification: 'jumio_verification',
  personalInformation: 'personal_information_input',
  mobileNumberVerification: 'mobile_number_verification',
  mobileNumberInput: 'mobile_number_input',
  documentInformationPassportDl: 'document_information_passport_dl',
  employmentInformation: 'personal_employment_information_input',
  ocrRetrivedInformationEdit: 'ocr_retrieved_information_edit',
  ocrRetrivedInformation: 'ocr_retrieved_information',
  referralCode: 'referral_code',
  addressInput: 'address_input',
  individualPoaUpload: 'individual_poa_upload',
  manualDocumentUpload: 'manual_document_upload',
  manualDocumentUploadId: 'manual_document_upload_id',
  manualDocumentUploadIdList: 'manual_document_upload_id_list',
  individualDocumentsUpload: 'individual_documents_upload',
  holdingVerifyScreen: 'holding_verify_screen',
  ekycAck: 'ekyc_acknowledgement',
  ekycSuccess: 'ekyc_successful',
  ekycServiceDown: 'ekyc_service_down',
  onboardingSuccess: 'onboarding_successful',
  scheduleInterview: 'schedule_interview',
  appointmentConfirmation: 'appointment_confirmation',
  accountUsageInput: 'account_usage_information_input',
  selfieUpload: 'individual_photo_upload',
  identityVerificationInput: 'identity_verification_input',
  onboardingVerification: 'onboarding_verification',
  kycDataReview: 'kyc_data_review'
};

export const OnBoarding = {
  mobileNumberScreen: [
    {
      countryCode: ['MY', 'AU', 'EU', 'GB', 'IN'],
      stepperData: {
        heading: 'Mobile number',
        description: `We need your number to verify your account as well as to send you verification codes so that 
          you can authorise your transactions.`,
        primaryBtnText: 'Next',
        secondaryBtnText: '',
        footerText: '',
        footerText1: '',
        skip: '',
        onboardingConsent: '',
        sendCountries: '',
        estimatedMonthlyVolume: '',
        primaryReasonForTransfer: '',
        addMore: '',
        showAll: '',
        reason: '',
        country: '',
        pep: '',
        pepToolTip: '',
        primaryReasonForTransferPlaceHolder: ''
      }
    }
  ],
  addressInformation: [
    {
      countryCode: ['AU', 'EU', 'GB'],
      stepperData: {
        heading: 'Address in {COUNTRY}',
        description:
          "We will need to verify your address, so make sure it's the same as the one on your utility bill or bank statement.",
        skip: '',
        primaryBtnText: 'Next',
        secondaryBtnText: 'Go back to search',
        footerText: '',
        footerText1: '',
        onboardingConsent: '',
        sendCountries: '',
        estimatedMonthlyVolume: '',
        primaryReasonForTransfer: '',
        addMore: '',
        showAll: '',
        reason: '',
        country: '',
        pep: '',
        pepToolTip: '',
        primaryReasonForTransferPlaceHolder: ''
      }
    },
    {
      countryCode: ['MY'],
      stepperData: {
        heading: 'Address in {COUNTRY}',
        description:
          'Please provide your permanent address in {COUNTRY}, as well as your mailing address if it is different.',
        skip: '',
        primaryBtnText: 'Next',
        secondaryBtnText: 'Go back to search',
        footerText: '',
        footerText1: '',
        onboardingConsent: '',
        sendCountries: '',
        estimatedMonthlyVolume: '',
        primaryReasonForTransfer: '',
        addMore: '',
        showAll: '',
        reason: '',
        country: '',
        pep: '',
        pepToolTip: '',
        primaryReasonForTransferPlaceHolder: ''
      }
    }
  ],
  employmentInformation: [
    {
      countryCode: ['MY', 'AU'],
      stepperData: {
        heading: 'Employment information',
        description: `In order to comply with regulations, we require information regarding your employment 
          status and the purpose of your account.`,
        primaryBtnText: 'Next',
        secondaryBtnText: '',
        footerText: '',
        footerText1: '',
        skip: '',
        onboardingConsent: '',
        sendCountries: '',
        estimatedMonthlyVolume: '',
        primaryReasonForTransfer: '',
        addMore: '',
        showAll: '',
        reason: '',
        country: '',
        pep: '',
        pepToolTip: '',
        primaryReasonForTransferPlaceHolder: ''
      }
    }
  ],
  onBoardingPersonalInfo: [
    {
      countryCode: ['AU', 'MY'],
      stepperData: {
        heading: 'Personal information',
        description: `To comply with regulations, we need you to share some of your personal details.
           Make sure they are accurate and match your ID documents.`,
        skip: '',
        primaryBtnText: 'Next',
        secondaryBtnText: '',
        footerText: `By proceeding you consent to {BRAND} disclosing above information to the required and applicable data sources and the 
          government agency to verify your identity as per {BRAND}’s Privacy Policy and its Terms & Conditions.`,
        footerText1: `I hereby give my consent to {VENDOR} to disclose above information to required and applicable data sources and 
          government agency to verify my identity as per {VENDOR}’s privacy policy and its terms & conditions`,
        onboardingConsent: `I hereby give my consent to {BRAND} to disclose above information to required and applicable data sources and
         government agency to verify my identity as per {BRAND}’s privacy policy and its terms & conditions`,
        sendCountries: '',
        estimatedMonthlyVolume: '',
        primaryReasonForTransfer: '',
        addMore: '',
        showAll: '',
        reason: '',
        country: '',
        pep: '',
        pepToolTip: '',
        primaryReasonForTransferPlaceHolder: ''
      }
    },
    {
      countryCode: ['EU', 'GB'],
      stepperData: {
        heading: 'Personal information',
        description: `To comply with regulations, we need you to share some of your personal details.
           Make sure they are accurate and match your ID documents.`,
        skip: '',
        primaryBtnText: 'Next',
        secondaryBtnText: '',
        footerText: ``,
        footerText1: ``,
        onboardingConsent: `I agree to {BRAND} processing my live photograph for a one-time ID
         verification by comparing it to the ID documentation provided and that any further consent will be re-requested.`,
        sendCountries: '',
        estimatedMonthlyVolume: '',
        primaryReasonForTransfer: '',
        addMore: '',
        showAll: '',
        reason: '',
        country: '',
        pep: '',
        pepToolTip: '',
        primaryReasonForTransferPlaceHolder: ''
      }
    }
  ],
  identityCheck: [
    {
      countryCode: ['AU'],
      stepperData: {
        heading: 'Identity check',
        description: 'Get verified instantly by scanning your \n ID document now!',
        skip: '',
        primaryBtnText: 'Scan ID document',
        secondaryBtnText: 'Enter details manually',
        footerText: '',
        footerText1: '',
        onboardingConsent: '',
        sendCountries: '',
        estimatedMonthlyVolume: '',
        primaryReasonForTransfer: '',
        addMore: '',
        showAll: '',
        reason: '',
        country: '',
        pep: '',
        pepToolTip: '',
        primaryReasonForTransferPlaceHolder: ''
      }
    },
    {
      countryCode: ['MY', 'EU', 'GB'],
      stepperData: {
        heading: 'Verify your identity',
        description: `Grab your ID documents and find the best lighting to click a picture.
           For a smooth experience, make sure you follow the instructions carefully.`,
        skip: '',
        primaryBtnText: 'Scan ID document',
        secondaryBtnText: '',
        footerText: '',
        footerText1: '',
        onboardingConsent: '',
        sendCountries: '',
        estimatedMonthlyVolume: '',
        primaryReasonForTransfer: '',
        addMore: '',
        showAll: '',
        reason: '',
        country: '',
        pep: '',
        pepToolTip: '',
        primaryReasonForTransferPlaceHolder: ''
      }
    }
  ],
  accountUsage: [
    {
      countryCode: ['EU', 'GB'],
      stepperData: {
        description: `We are required by law to establish the nature and purpose of your account.
          Don't worry, it's as easy as sharing with us how you plan to use your Instarem account.`,
        heading: 'Account usage',
        primaryBtnText: 'Next',
        sendCountries: 'Countries you will send to',
        countriesDropdownSubHeader: 'Select countries, then press ‘Apply’',
        primaryReasonForTransfer: 'Primary reason for transfers',
        reason: 'Reason',
        country: 'Country',
        estimatedMonthlyVolume: 'Estimated monthly volume',
        addMore: 'Add more',
        showAll: 'Show all',
        pep: 'Are you a Politically Exposed Person (PEP)?',
        pepToolTip: `A PEP (Politically Exposed Person) is a current or former senior official in the executive, 
         legislative, administrative, military, or judicial branch of a government, a senior official of a political party,
         or a senior executive of a government owned enterprise. Also included in the definition of a PEP are immediate family members 
         or close associates of a person that meets the description above.`,
        primaryReasonForTransferPlaceHolder: 'Type your reason for transfer here',
        secondaryBtnText: '',
        footerText: '',
        footerText1: '',
        skip: '',
        onboardingConsent: ''
      }
    }
  ]
};

//Total steps = number of stepper component in figma + 1
export const totalSteps = {
  AU: 6,
  MY: 6,
  EU: 8,
  GB: 8,
  IN: 9
};
export const screenSettings = {
  mobileNumberScreen: [
    {
      countryCode: ['AU'],
      stepperData: {
        stepNumber: 3,
        totalSteps: totalSteps.AU
      },
      constants: {}
    },
    {
      countryCode: ['MY'],
      stepperData: {
        stepNumber: 1,
        totalSteps: totalSteps.MY
      },
      constants: {}
    },
    {
      countryCode: ['EU', 'GB'],
      stepperData: {
        stepNumber: 3,
        totalSteps: totalSteps.EU
      },
      constants: {}
    },
    {
      countryCode: ['IN'],
      stepperData: {
        stepNumber: 2,
        totalSteps: totalSteps.IN
      },
      constants: {}
    }
  ],
  addressInformation: [
    {
      countryCode: ['AU'],
      stepperData: {
        stepNumber: 5,
        totalSteps: totalSteps.AU
      },
      constants: {
        toggleAddressText: 'Enter address manually',
        searchPlaceHolder: 'Search with your postal code',
        checkBoxText: ''
      }
    },
    {
      countryCode: ['MY'],
      stepperData: {
        stepNumber: 3,
        totalSteps: totalSteps.MY
      },
      constants: {
        toggleAddressText: 'Enter address manually',
        searchPlaceHolder: 'Search street number',
        checkBoxText: 'Mailing address is same as residence address'
      }
    },
    {
      countryCode: ['EU'],
      stepperData: {
        stepNumber: 5,
        totalSteps: totalSteps.EU
      },
      constants: {
        toggleAddressText: 'Enter address manually',
        searchPlaceHolder: 'Search postal code',
        checkBoxText: ''
      }
    },
    {
      countryCode: ['GB'],
      stepperData: {
        stepNumber: 5,
        totalSteps: totalSteps.GB
      },
      constants: {
        toggleAddressText: 'Enter address manually',
        searchPlaceHolder: 'Search street number',
        checkBoxText: ''
      }
    }
  ],
  editYourInformation: [
    {
      countryCode: ['AU'],
      stepperData: {
        stepNumber: 4,
        totalSteps: totalSteps.AU
      },
      constants: {}
    }
  ],
  documentInformation: [
    {
      countryCode: ['AU'],
      stepperData: {
        stepNumber: 4,
        totalSteps: totalSteps.AU,
        extraWording: '- part 2'
      },
      constants: {}
    }
  ],
  onBoardingPersonalInfo: [
    {
      countryCode: ['AU'],
      stepperData: {
        stepNumber: 4,
        totalSteps: totalSteps.AU,
        extraWording: '- part 1'
      },
      constants: {}
    },
    {
      countryCode: ['MY'],
      stepperData: {
        stepNumber: 2,
        totalSteps: totalSteps.MY
      },
      constants: {}
    },
    {
      countryCode: ['EU', 'GB'],
      stepperData: {
        stepNumber: 4,
        totalSteps: totalSteps.EU
      },
      constants: {}
    }
  ],
  retrievedInformation: [
    {
      countryCode: ['AU'],
      stepperData: {
        stepNumber: 4,
        totalSteps: totalSteps.AU
      },
      constants: {}
    }
  ],
  employmentInformation: [
    {
      countryCode: ['MY'],
      stepperData: {
        stepNumber: 4,
        totalSteps: totalSteps.MY
      },
      constants: {}
    },
    {
      countryCode: ['AU'],
      stepperData: {
        stepNumber: 6,
        totalSteps: totalSteps.AU
      },
      constants: {}
    }
  ],
  identityCheck: [
    {
      countryCode: ['AU'],
      stepperData: {
        stepNumber: 4,
        totalSteps: totalSteps.AU
      },
      constants: {}
    },
    {
      countryCode: ['MY'],
      stepperData: {
        stepNumber: 5,
        totalSteps: totalSteps.MY
      },
      constants: {}
    },
    {
      countryCode: ['EU', 'GB'],
      stepperData: {
        stepNumber: 7,
        totalSteps: totalSteps.EU
      },
      constants: {}
    }
  ],
  accountUsage: [
    {
      countryCode: ['EU', 'GB'],
      stepperData: {
        stepNumber: 6,
        totalSteps: totalSteps.EU
      },
      constants: {}
    }
  ]
};

export const employmentInfoInputFields = {
  EMPLOYMENT_STATUS_FIELD: {
    placeHolder: 'Employment status'
  },
  OCCUPATION_FIELD: {
    placeHolder: 'Occupation'
  },
  EMPLOYER_NAME_FIELD: {
    placeHolder: 'Employer name'
  },
  PURPOSE_OF_ACCOUNT_FIELD: {
    placeHolder: 'Purpose of account'
  },
  REASON_OF_UNEMPLOYMENT_FIELD: {
    placeHolder: 'Reason of unemployment'
  },
  NATURE_OF_SELF_EMPLOYMENT_FIELD: {
    placeHolder: 'Nature of self employment'
  },
  UNIVERSITY_NAME_FIELD: {
    placeHolder: 'University name'
  }
};

export const personalInputFields = {
  FIRST_NAME_FIELD: {
    label: 'First name',
    placeHolder: 'As in your ID document'
  },
  MIDDLE_NAME_FIELD: {
    label: 'Middle name (optional)',
    placeHolder: 'As in your ID document'
  },
  LAST_NAME_FIELD: {
    label: 'Last name',
    placeHolder: 'As in your ID document'
  },
  DOB_FIELD: {
    label: 'Date of birth',
    placeHolder: 'DD/MM/YYYY'
  },
  NATIONALITY_FIELD: {
    label: 'Nationality',
    placeHolder: ''
  }
};
export const mobileVerificationFields = {
  MOBILE_NUMBER_FIELD: {
    label: 'Mobile number',
    placeHolder: 'Mobile number'
  }
};
export const ekycService = {
  ekycServiceDownHeading: 'eKYC service down',
  retryEkyc: 'Retry eKYC',
  proceedWithManualUpload: 'Proceed with manual upload',
  ekycService: [
    {
      countryCode: ['AU'],
      ekycData: {
        key: 'Veriff',
        note: 'Without scanning your ID, it will take us up to 48 hours to approve your account.',
        stepTitle: 'Step XX',
        checkPoint: {
          note1: 'Your original passport or',
          note2: "Your original Australian driver's license",
          title:
            'Scan one of the below docs. We will retrieve your name, DOB, nationality and address to speed things up!'
        }
      }
    },
    {
      countryCode: ['MY'],
      ekycData: {
        key: 'Jumio',
        stepTitle: 'Step XX',
        checkPoint: {
          note1: 'Your original MyPR or MyKAD',
          note2: 'Your selfie',
          title: 'You will be asked to provide a photo of the following:',
          note1ForNonMy: 'Your original Passport',
          note1ForOther: 'Your original Passport'
        },
        newFormat: {
          title: 'Grab your ID and keep it ready',
          description: 'You’ll scan it in the next step, no uploads allowed, so keep it handy!',
          sameNationalityDocRequired: [
            {
              title: 'Your original MyPR or MyKAD',
              description: 'Simply scan your document',
              icon: 'identity',
              iconWeb: 'document-id'
            },
            {
              title: 'Your selfie',
              description: 'Take a selfie with your face clearly visible',
              icon: 'selfie',
              iconWeb: 'person-focus-scan'
            }
          ],
          otherNationalityDocRequired: [
            {
              title: 'Your original passport',
              description: 'Simply scan your document',
              icon: 'identity',
              iconWeb: 'document-id'
            },
            {
              title: 'Your selfie',
              description: 'Take a selfie with your face clearly visible',
              icon: 'selfie',
              iconWeb: 'person-focus-scan'
            }
          ]
        },
        ekycServiceDownDescription: `Unfortunately, our eKYC services are currently unavailable. Please upload your ID document 
        details manually and schedule a visit to our office for verification.`
      }
    },
    {
      countryCode: ['GB'],
      ekycData: {
        key: 'Onfido',
        stepTitle: 'Step XX',
        checkPoint: {
          note1: 'Your original passport or residence permit and',
          note2: 'Your selfie',
          note3: 'Your original passport or residence permit and',
          title: 'You will be asked to provide a photo of the following:',
          note1ForOther: 'Your original passport or national ID or residence permit and',
          poaNote:
            'Note: We may request a Proof of Address (bank statement, utility bill, or government letter) after this step.'
        },
        ekycServiceDownDescription:
          'Unfortunately, our eKYC services are currently unavailable. Our team will reach out to you for completing the verification.'
      }
    },
    {
      countryCode: ['EU'],
      ekycData: {
        key: 'Onfido',
        stepTitle: 'Step XX',
        checkPoint: {
          note1: 'Your original passport or residence permit and ',
          note2: 'Your selfie',
          note3: 'Your original passport or residence permit and',
          note1ForOther: 'Your original passport or national ID or residence permit and',
          title: 'You will be asked to provide a photo of the following:'
        },
        ekycServiceDownDescription:
          'Unfortunately, our eKYC services are currently unavailable. Our team will reach out to you for completing the verification.'
      }
    }
  ],
  kycDataReview: {
    MY: {
      detailsMismatch: {
        title: 'We couldn’t verify some of your details',
        description: 'There’s a mismatch with your document. Please confirm the correct details.',
        primaryBtn: 'Use document details',
        secondaryBtn: 'Update your details',
        yourDetailsTitle: 'Your details',
        documentDetailsTitle: 'Document details',
        fullName: 'Full name',
        dob: 'Date of birth',
        nationality: 'Nationality'
      },
      documentError: {
        title: 'We couldn’t verify your document',
        primaryBtn: 'Try again',
        errors: {
          PART_OF_DOCUMENT_HIDDEN: {
            caption: 'Information is covered',
            description:
              'Some details are not visible. Please upload the full document with no obstructions.',
            cdnImageName: 'document-hidden'
          },
          BLURRED: {
            caption: 'Blurry image',
            description: 'The document is out of focus. Please upload a sharp and clear photo.',
            cdnImageName: 'document-blurred'
          },
          PHOTOCOPY: {
            caption: 'Invalid image detected',
            description:
              'Photocopies and digital copies are not accepted. Please upload a direct photo of the original document.',
            cdnImageName: 'document-photocopy'
          },
          DIGITAL_COPY: {
            caption: 'Invalid image detected',
            description:
              'Photocopies and digital copies are not accepted. Please upload a direct photo of the original document.',
            cdnImageName: 'document-photocopy'
          },
          GLARE: {
            caption: 'Glare on document',
            description:
              'Some details are not visible. Please upload a clear photo without flash or reflection.',
            cdnImageName: 'document-glare'
          },
          PART_OF_DOCUMENT_MISSING: {
            caption: 'Document cut off',
            description:
              'Some details are not visible. Please upload a clear photo showing the full document.',
            cdnImageName: 'document-missing'
          },
          MISSING_PAGE: {
            caption: 'Front',
            secondaryCaption: 'Back',
            description:
              'We’re missing the back of your document. Please upload both sides to continue.',
            cdnImageName: 'document-missing-page-front',
            cdnSecondaryImageName: 'document-missing-page-back'
          },
          DAMAGED_DOCUMENT: {
            caption: 'Document unclear',
            description:
              'Some details are not visible. Please upload a clear and readable photo of the document.',
            cdnImageName: 'document-damaged'
          },
          BAD_QUALITY_IMAGE: {
            caption: 'Document unclear',
            description:
              'Some details are not visible. Please upload a clear and readable photo of the document.',
            cdnImageName: 'document-damaged'
          },
          NOT_A_DOCUMENT: {
            caption: 'Not a document',
            description:
              'Invalid photo detected. Please upload a direct photo of a valid ID document.',
            cdnImageName: 'document-not-a-document'
          }
        }
      }
    }
  }
};

export const addressFieldKeyMap: CountryAddressFieldKeyMap = {
  AU: {
    unit_number: {
      placeholder: 'Unit no.',
      width: 210
    },
    street_number: {
      placeholder: 'Street no.',
      width: 210
    },
    street_name: {
      placeholder: 'Street'
    },
    postcode: {
      placeholder: 'Postal code'
    },
    state: {
      label: 'State',
      placeholder: 'Please enter full name of the state'
    },
    suburb: {
      placeholder: 'Suburb'
    }
  },
  MY: {
    unit_number: {
      placeholder: 'Unit no.'
    },
    street_name: {
      placeholder: 'Street'
    },
    postcode: {
      placeholder: 'Postcode'
    },
    state: {
      label: 'State',
      placeholder: 'Please enter full name of the state'
    },
    city: {
      placeholder: 'City'
    }
  },
  GB: {
    unit_number: {
      placeholder: 'Unit no. (optional)',
      width: 210
    },
    building_number: {
      placeholder: 'Building no.',
      width: 210
    },
    building_name: {
      placeholder: 'Building name'
    },
    street_name: {
      placeholder: 'Street name'
    },
    city: {
      placeholder: 'City'
    },
    postcode: {
      placeholder: 'Postcode'
    }
  },
  EU: {
    unit_number: {
      placeholder: 'Unit no. (optional)'
    },
    address1: {
      placeholder: 'Address Line 1'
    },
    address2: {
      placeholder: 'Address Line 2'
    },
    city: {
      placeholder: 'City'
    },
    postcode: {
      placeholder: 'Postal code'
    }
  },
  DE: {
    street_name: {
      placeholder: 'Street name'
    },
    building_number: {
      placeholder: 'Building no. (optional)',
      width: 210
    },
    unit_number: {
      placeholder: 'Unit no. (optional)',
      width: 210
    },
    city: {
      placeholder: 'City'
    },
    postcode: {
      placeholder: 'Postal code'
    }
  },
  NL: {
    street_name: {
      placeholder: 'Street name'
    },
    building_number: {
      placeholder: 'Building no. (optional)',
      width: 210
    },
    unit_number: {
      placeholder: 'Unit no. (optional)',
      width: 210
    },
    city: {
      placeholder: 'City'
    },
    postcode: {
      placeholder: 'Postal code'
    }
  },
  IT: {
    street_name: {
      placeholder: 'Street name'
    },
    building_number: {
      placeholder: 'Building no.',
      width: 210
    },
    unit_number: {
      placeholder: 'Unit no. (optional)',
      width: 210
    },
    city: {
      placeholder: 'City'
    },
    postcode: {
      placeholder: 'Postal code'
    },
    province: {
      placeholder: 'Province'
    }
  }
};
export const onBoardingAcknowledgeData = {
  allSet: 'You’re all set!',
  sendMoney: 'Send money',
  helperText3: 'Contact Support',
  homeButtonNew: 'Go to home',
  myTransferNote:
    'You can transfer up to {limit_currency}. If you attempt to transfer more, you will be asked to provide your employment pass details.',
  startSendingMoney: 'Start sending money to your friends, family or anyone.',
  continueToGetAmaze: 'Continue to get amaze',
  continueToTransfer: 'Continue to transfer',
  startSendingMoneyNew: 'Start sending money to your friends and family straight away.',
  successGoToHomeScreen: 'Go to home screen',
  continueWithMyTransfer: 'Continue with my transfer'
};
export const manualUploadUserData = {
  heading: 'Submitted Successfully!',
  sub2heading: 'You’ll be notified once your account is ready. This may take up to 24 hours.',
  subHeading: 'We are reviewing your profile'
};

export const VerificationHolding = {
  verificationText: 'Identity verification in process...',
  fewMomentsText: 'This will only take a few moments',
  holdingVerifyScreenTimerInMiliSeconds: 15000
};
export const scheduleAppointmentData = {
  scheduleAppointmentData: [
    {
      countryCode: ['MY'],
      scheduleVerificationData: {
        heading: 'Schedule verification visit',
        dateLabel: 'Preferred date',
        submitBtn: 'Submit',
        timeLabel: 'Time slot',
        description:
          'At the scheduled time, one of our background verified agents will be available at our office to verify your ID proof.',
        addressHeader: 'Office location',
        datePlaceHolder: 'Select date',
        timePlaceHolder: 'Select slot'
      },
      appointmentConfirmationData: {
        heading: 'Appointment confirmed',
        location: 'Location',
        needHelp: 'Need help?',
        dateLabel: 'Date and time',
        chatWithUs: 'Chat with us',
        description:
          "Please remember to bring the original versions of the documents you've shared with us for your appointment.",
        addToCalendar: 'Add to calendar',
        contactSupport: 'Contact support',
        goToHomeScreen: 'Go to home screen'
      }
    }
  ]
};
export const slots = [
  { key: 1, value: '9', text: '9am to 12pm' },
  { key: 2, value: '12', text: '12pm to 3pm' },
  { key: 3, value: '3', text: '3pm to 6pm' }
];
export const reasonsOFTransfer = [
  'TRANSFERS_TO_OWN_ACCOUNT',
  'TRANSFERS_TO_FRIENDS_OR_FAMILY',
  'PROPERTY_GOODS_OR_SERVICES_PAYMENTS'
];
export const countriesList = ['IN', 'NP', 'PH'];

export const US_CONSTANTS = {
  ssnPlaceholder: 'Enter 9-digit SSN'
};
export const SSN = 'SSN';
export const ACCOUNT_USAGE_FORM = 'accountUsageForm';

export const ADDRESS_VERIFICATION_FIELD_TYPES = {
  textField: 'text_field',
  datePicker: 'date_picker',
  dropdown: 'dropdown'
};

export const documentErrorTypes = {
  MISSING_PAGE: 'MISSING_PAGE',
  PART_OF_DOCUMENT_HIDDEN: 'PART_OF_DOCUMENT_HIDDEN',
  PART_OF_DOCUMENT_MISSING: 'PART_OF_DOCUMENT_MISSING',
  BLURRED: 'BLURRED',
  DIGITAL_COPY: 'DIGITAL_COPY',
  GLARE: 'GLARE',
  BAD_QUALITY_IMAGE: 'BAD_QUALITY_IMAGE',
  DAMAGED_DOCUMENT: 'DAMAGED_DOCUMENT',
  PHOTOCOPY: 'PHOTOCOPY',
  NOT_A_DOCUMENT: 'NOT_A_DOCUMENT',
  MISSING_SIGNATURE: 'MISSING_SIGNATURE'
};
